import {find} from "lodash";
import {matchViewMode} from "../config/constants";

export const findViewMode = (id) => {
    return find(matchViewMode, mvm => parseInt(mvm.id) === parseInt(id));
}